<template>
  <div class="footer-container">
      <div class="hr-wrapper">
        <div class="spacer"></div>
        <router-link class="no-link-style d-only" :to="{path: '/'}">
          <img src="./../assets/img/aer_small_black.svg" style="height: 19px; position: relative; top: 4px;">
        </router-link>
        <span class="d-only">|</span>
        <router-link v-if="lang === 'fr'" :to="{path: '/mentions-legales'}">
          Mentions Légales et crédits
        </router-link>
        <router-link v-else-if="lang === 'en'" :to="{path: '/en/mentions-legales/'}">
          Legal notices / Credits
        </router-link>
<!--         &nbsp;|
        <a href="https://fr-fr.facebook.com/ArtsEnResidence/" target="blank">
          Facebook
        </a> -->
        <span>|</span>
        <a target="_blank" href="https://www.facebook.com/ArtsEnResidence/">Facebook</a>
        <span>|</span>
        <a target="_blank" href="https://www.instagram.com/arts_en_residence/?hl=fr">Instagram</a>
        <span>|</span>
        <a target="_blank" href="https://fr.linkedin.com/company/arts-en-r%C3%A9sidence-r%C3%A9seau-national">Linkedin</a>
        <span>|</span>
        <a target="_blank" href="https://www.youtube.com/channel/UCWkFR7BqedgF8hCYrekzQCg">YouTube</a>
        <span>|</span>
        <router-link v-if="lang === 'fr'" :to="{path: '/nous-contacter/'}">
          Contact
        </router-link>
        <router-link v-else-if="lang==='en'" :to="{path: '/en/nous-contacter/'}">
          Contact
        </router-link>
        <span>|</span>
        <a v-if="lang === 'fr'" target="_blank" href="https://c70d5504.sibforms.com/serve/MUIEACPuenWgYaU84dS48eDTLZ0vCQ47wrT8ftG4qLd33czOPlVKmARgMTG_IFSrOJUw_PsO449ixQiv08v4An-_Lm-d0q-8ILrvxDuaFz95ta_GqJ3IJ_LygY7QUSrL2oR3L7NNSBPbhK9wl6700Dj2XTJMCCOxQINdq0iO2vTwLKdk5_Nlf9QrXmk88I6mzTL7uLpuJLFbK7jd" onclick="window.open('https://c70d5504.sibforms.com/serve/MUIEACPuenWgYaU84dS48eDTLZ0vCQ47wrT8ftG4qLd33czOPlVKmARgMTG_IFSrOJUw_PsO449ixQiv08v4An-_Lm-d0q-8ILrvxDuaFz95ta_GqJ3IJ_LygY7QUSrL2oR3L7NNSBPbhK9wl6700Dj2XTJMCCOxQINdq0iO2vTwLKdk5_Nlf9QrXmk88I6mzTL7uLpuJLFbK7jd','popup','width=700,height=800'); return false;">S’inscrire à la newsletter</a>
        <a v-else-if="lang === 'en'" target="_blank" href="https://c70d5504.sibforms.com/serve/MUIEACPuenWgYaU84dS48eDTLZ0vCQ47wrT8ftG4qLd33czOPlVKmARgMTG_IFSrOJUw_PsO449ixQiv08v4An-_Lm-d0q-8ILrvxDuaFz95ta_GqJ3IJ_LygY7QUSrL2oR3L7NNSBPbhK9wl6700Dj2XTJMCCOxQINdq0iO2vTwLKdk5_Nlf9QrXmk88I6mzTL7uLpuJLFbK7jd" onclick="window.open('https://c70d5504.sibforms.com/serve/MUIEACPuenWgYaU84dS48eDTLZ0vCQ47wrT8ftG4qLd33czOPlVKmARgMTG_IFSrOJUw_PsO449ixQiv08v4An-_Lm-d0q-8ILrvxDuaFz95ta_GqJ3IJ_LygY7QUSrL2oR3L7NNSBPbhK9wl6700Dj2XTJMCCOxQINdq0iO2vTwLKdk5_Nlf9QrXmk88I6mzTL7uLpuJLFbK7jd','popup','width=700,height=800'); return false;">Suscribe to the newsletter</a>

<!--         <router-link class="" style="float: right" :to="{path: '/english'}">
          <strong>English</strong>
        </router-link> -->

        <div class="spacer"></div>
        <div class="spacer"></div>
      </div>
  </div>
</template>

<script>


export default {
  name: 'Footer',
  components: {
  },
  computed: {
  },
  props: ['lang'],
  data () {
    return {
   //    lang: global.lang      
    }
  },
  methods: {

  },
  created () {

  },
  watch: {
    mapIsReady (val) {
      console.log(val)
    },
    $route () {
      if (app.$route.path.split('/')[1] == 'en'){
        this.lang = 'en'
        this.getNavigation()
        this.getSideNavigation()
      }else{
        this.lang = 'fr'
        this.getNavigation()
        this.getSideNavigation()       
      }
      this.lang = global.lang
    }

  }
}
</script>

<style>


</style>


// WEBPACK FOOTER //
// src/components/Footer.vue